module.exports = __webpack_public_path__ + "static/payment-history-mobile-41616253cf0a4bdbf3e24244ef0e695a.png";